import { css } from "@compiled/react";

const iconWrapperStyle = css({
    paddingInlineEnd: 16,
    display: "flex"
});

const NotificationsComponent = () => {
    return (
        <div css={iconWrapperStyle}>
            <NotificationsIcon />
        </div>
    );
};

const NotificationsIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="none"
            viewBox="0 0 22 22"
        >
            <path
                fill="#101214"
                d="M8.829 18.563a2.404 2.404 0 0 0 4.342 0zm-2.642-6.689c0 .296-.083.586-.24.837L3.578 16.5h14.844l-2.37-3.79c-.156-.25-.24-.54-.24-.836V6.875a4.813 4.813 0 0 0-9.625 0zm11.688-.138 2.459 3.934c.787 1.26-.119 2.893-1.604 2.893h-3.382a4.47 4.47 0 0 1-8.696 0H3.27c-1.485 0-2.39-1.634-1.604-2.893l2.459-3.934V6.875a6.875 6.875 0 0 1 13.75 0z"
            />
        </svg>
    );
};

export default NotificationsComponent;
